import React from 'react'

export default function AdminProfilePage() {
  return (
    <div>
      
    </div>
  )
}
